import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { I18nProvider } from "@/context/I18nContext";
import { Toaster } from "@/components/ui/sonner";

import GuestOnly from "@/components/GuestOnly";
import AppLayout from "@/components/AppLayout";

import Login from "@/pages/Login";
import Home from "@/pages/Home";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/History";
import SessionDetail from "@/pages/SessionDetail";
import LeadDetail from "@/pages/LeadDetail";
import AIAnalysis from "@/pages/AIAnalysis";
import BusinessInfo from "@/pages/BusinessInfo";
import Settings from "@/pages/Settings";
import Search from "@/pages/Search";
import CompanyComparison from "@/pages/CompanyComparison";

function OnboardingGate() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Yükleniyor…</div>;
  if (!user) return <Navigate to="/giris" replace />;
  if (user.onboarded) return <Navigate to="/panel" replace />;
  return <Onboarding />;
}

export default function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/giris" element={<GuestOnly><Login /></GuestOnly>} />
              <Route path="/kayit" element={<GuestOnly><Register /></GuestOnly>} />
              <Route path="/sifremi-unuttum" element={<GuestOnly><ForgotPassword /></GuestOnly>} />
              <Route path="/sifremi-sifirla" element={<GuestOnly><ResetPassword /></GuestOnly>} />

              <Route path="/karsilama" element={<OnboardingGate />} />

              <Route element={<AppLayout />}>
                <Route path="/panel" element={<Dashboard />} />
                <Route path="/arama" element={<Search />} />
                <Route path="/gecmis" element={<Leads />} />
                <Route path="/gecmis/:id/karsilastir" element={<CompanyComparison />} />
                <Route path="/gecmis/:id" element={<SessionDetail />} />
                {/* Backward-compat: old /musteriler now redirects to History. */}
                <Route path="/musteriler" element={<Navigate to="/gecmis" replace />} />
                <Route path="/musteriler/:id" element={<LeadDetail />} />
                <Route path="/ai-analiz" element={<AIAnalysis />} />
                <Route path="/isletme" element={<BusinessInfo />} />
                <Route path="/ayarlar" element={<Settings />} />
              </Route>

              <Route path="/" element={<GuestOnly><Home /></GuestOnly>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </I18nProvider>
    </ThemeProvider>
  );
}
